/**
 * Hook for updating user via PATCH /api/admin/users/:id.
 */
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { message } from 'antd';
import { updateUserProfile } from '../services/userManagementService';
import type { UpdateUserProfilePayload } from '../services/userManagementService';

export function useUpdateUser(
  userId: string | undefined,
  options?: {
    onSuccess?: () => void;
    onError?: (err: unknown) => void;
  }
) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: UpdateUserProfilePayload) => {
      if (!userId) throw new Error('userId required');
      return updateUserProfile(userId, payload);
    },
    onSuccess: (_, __, context) => {
      message.success('Cập nhật thông tin thành công');
      queryClient.invalidateQueries({ queryKey: ['user', userId, 'overview'] });
      queryClient.invalidateQueries({ queryKey: ['users'] });
      queryClient.invalidateQueries({ queryKey: ['admin', 'users'] });
      options?.onSuccess?.();
    },
    onError: (err: unknown) => {
      const ax = err as { response?: { data?: { message?: string } } };
      message.error(ax.response?.data?.message || 'Cập nhật thất bại');
      options?.onError?.(err);
    },
  });
}
